module.exports = __webpack_public_path__ + "img/UTGOBL.9c3df376.png";